module.exports = __webpack_public_path__ + "img/12.e5e052f2.gif";